import React, { useEffect, useRef } from 'react';

interface ModalContentProps {
  closeModal: () => void;
  errorMessage: string | null;
  setErrorMessage: (val: string | null) => void;
  setIsInputOpen: (val: boolean) => void;
}

const ModalContent: React.FC<ModalContentProps> = ({
  closeModal,
  errorMessage,
  setErrorMessage,
  setIsInputOpen,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        closeModal();
        setErrorMessage(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeModal, setErrorMessage]);

  return (
    <div
      ref={modalRef}
      className="h-[135px] w-[528px] rounded-[12px] border bg-white"
      style={{ border: '1px solid rgba(229, 231, 235, 1)' }}
    >
      <p className="mb-4 mt-[20px] flex items-center justify-center text-center font-inter text-lg font-normal leading-[17px] text-red-600">
        <svg
          className="mr-2 h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(224, 36, 36, 1)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="rgba(224, 36, 36, 1)"
            fill="none"
          />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12" y2="16" />
        </svg>
        {errorMessage ? errorMessage : 'We were not able to retrieve any data'}
      </p>
      <div className="mt-6 px-4">
        <button
          onClick={() => {
            closeModal();
            setErrorMessage(null);
            setIsInputOpen(true);
          }}
          className="leading-1 flex w-full justify-center rounded-lg bg-[#1C64F2] px-3 py-1.5 font-inter text-lg font-medium tracking-wider text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default ModalContent;
